export default __webpack_public_path__ + "assets/images/c60bab64ec22607f3f01537e35e8d82f.png";